import styles from './web-updates.module.scss';
import { Col, Row } from 'reactstrap';
import { UseTableHook } from '../../requestUtils';
import PageTitle from '../../page-title/page-title';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import WebUpdatesGrid from '../web-updates-grid/web-updates-grid';
import { IWebUpdates } from '../../_models/web-updates';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface WebUpdatesProps { }

export function WebUpdates(props: WebUpdatesProps) {
  const { t } = useTranslation();
  const { data, onDateChange, isLoading, getData, dateRange } = UseTableHook<IWebUpdates>(`Licenses/webupdates`);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.webUpdates")} />
            <WebUpdatesGrid
              webUpdates={data}
              dateRange={dateRange}
              onRefresh={getData}
              isLoading={isLoading}
              onDateChange={onDateChange}
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default WebUpdates;